module.exports = __webpack_public_path__ + "static/laura_05-5bf1ab74e06d955ab4c44b5ca775a522.jpg";